const sitemapButton = document.querySelector('.nav--sitemap');

sitemapButton.childNodes[1].addEventListener("click", function() {
    sitemapButton.classList.toggle('active');
});
